const root = '/groups';
const baseRoute = (path = '') => `${root}${path}`;

export default {
  root,
  detail: (id: number | string = ':contactId') => baseRoute(`/${id}/`),
} as const;
